import * as Yup from "yup";

const schema = Yup.object({
  attributes: Yup.object({
    ProviderIdentification: Yup.string().required(
      "Provider Identification cannot be blank"
    ),
    ApplicationName: Yup.string().required("Application Name cannot be blank"),
    CertificationCode: Yup.string().required(
      "Certification Code cannot be blank"
    ),
    KEK: Yup.string().required("KEK cannot be blank"),
    KEKIdentifier: Yup.string().required("KEK Identifier cannot be blank"),
    KEKVersion: Yup.string().required("KEK Version cannot be blank"),
  }),
});

export default schema;
